(async function() {
  if (window.clientConfig.features.enabledTestLogs && !window.__erudaLoaded) {
    window.__erudaLoaded = true;

    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/eruda";
    script.async = true;
    script.onload = function() {
      if (window.eruda) {
        window.eruda.init();
      }
    };
    document.body.appendChild(script);
  }
})();
